<template>
  <div id="container" class="container mt-5 mb-5">
    <form class="mt-5">
      <h2 class="text-head" style="padding-top: 2rem">ผู้รายงาน</h2>
      <div class="mt-3 form-div">
        <div class="pt-2 pl-5 pr-2">
          <div class="mt-3 row">
            <div class="col-md-4 form-group row">
              <label class="col-4 col-form-label">1. ผู้รายงาน</label>
              <div class="col-8">
                <multiselect
                  id="title"
                  v-model="form.title"
                  :options="titleOptions"
                  deselect-label=""
                  placeholder="คำนำหน้า"
                  select-label=""
                  selectedLabel="">
                </multiselect>
                <input v-if="form.title === 'อื่นๆ'" id="other_title" v-model="form.other_title"
                       class="form-control mt-1" type="text" placeholder="ระบุคำนำหน้า">
              </div>
            </div>
            <div class="col-md-4 form-group row">
              <label class="col-4 col-form-label">ชื่อ - นามสกุล</label>
              <div class="col-8">
                <input id="name" v-model="form.name"
                       class="form-control" type="text">
              </div>
            </div>
            <div class="col-md-4 form-group row">
              <label class="col-4 col-form-label">ตำแหน่ง</label>
              <div class="col-8">
                <input id="role" v-model="form.role"
                       class="form-control" type="text">
              </div>
            </div>
          </div>
          <div class="mt-3 row">
            <div class="col-md-4 form-group row">
              <label class="col-4 col-form-label">2. หน่วยงาน</label>
              <multiselect
                id="department"
                v-model="form.department"
                :options="optionDepartments"
                class="w-50 style-multiselect"
                deselect-label=""
                label="name"
                placeholder="เลือกหน่วยงาน"
                select-label=""
                selectedLabel=""
                track-by="name">
              </multiselect>
            </div>
            <div class="col-md-4 form-group row">
              <label class="col-4 col-form-label">ชื่อหน่วยงาน</label>
              <div class="col-8">
                <input id="department-name" v-model="form.department_name"
                       class="form-control" type="text">
              </div>
            </div>
            <div class="col-md-4 form-group row">
              <label class="col-4 col-form-label">จังหวัด</label>
              <multiselect
                id="province_department"
                v-model="form.province_department"
                :options="optionProvince"
                class="w-50 style-multiselect"
                deselect-label=""
                label="name"
                placeholder="เลือกจังหวัด"
                select-label=""
                selectedLabel=""
                track-by="name">
              </multiselect>
            </div>
          </div>
          <div class="mt-3 row">
            <div class="col-lg-4 col-md-12 form-group row">
              <label class="col-md-2 col-lg-4 col-4 col-form-label">3. เบอร์โทร</label>
              <div class="col-md-6 col-lg-7 col-6">
                <input id="phone_number_department" v-model="form.phone_number_department"
                       class="form-control" type="text">
              </div>
            </div>
            <div class="col-lg-4 col-md-12  form-group row">
              <label class="col-md-2 col-lg-4 col-4 col-form-label">โทรสาร</label>
              <div class="col-md-6 col-lg-7 col-6">
                <input id="fax_number_department" v-model="form.fax_number_department"
                       class="form-control" type="text">
              </div>
            </div>
            <div class="col-lg-4 col-md-12  form-group row">
              <label class="col-md-2 col-lg-4 col-4 col-form-label">วันที่รายงาน</label>
              <div class="col-md-6 col-lg-7 col-6 ">
                <date-picker id="report_date" ref="datePicker"
                             v-model="form.report_date"
                             :format="changeFormat"
                             :lang="lang"
                             :not-after="currentDate"
                             width="100%"
                             @focus="initDate(form.report_date)"
                             @calendar-change="convertYear">
                </date-picker>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--      <h2 class="mt-5 text-head">พื้นที่ของเหตุการณ์</h2>-->
      <!--      <div id="google-form" class="form-div">-->
      <!--        &lt;!&ndash; สร้าแผนที่และกำหนดคุณสมบัติ &ndash;&gt;-->
      <!--        <div class="row pt-2 pl-5 pr-lg-5 pr-3 pb-3">-->
      <!--          <label class="col-2 col-form-label ">ค้นหาสถานที่</label>-->
      <!--          <div class="col-10">-->
      <!--            <gmap-autocomplete-->
      <!--              class="form-control"-->
      <!--              @place_changed="setPlace"-->
      <!--              :placeholder="form.location" id="searchLocation">-->
      <!--            </gmap-autocomplete>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <gmap-map :center="startLocation" :zoom="15" style="width: 100%; height: 420px;" @click="setPlaceNEW">-->
      <!--          &lt;!&ndash; สร้าง marker ตามค่า coordinates ที่เราเซตไว้ แล้ว loop ออกมาแสดงผล &ndash;&gt;-->
      <!--          <gmap-marker-->
      <!--            v-for="(item, key) in markers"-->
      <!--            :key="key" :position="getPosition(item)"-->
      <!--            :clickable="true"-->
      <!--            @click="toggleInfo()"></gmap-marker>-->
      <!--        </gmap-map>-->
      <!--        <br>-->
      <!--      </div>-->

      <h2 class="mt-5 text-head">ก. รายละเอียดของเหตุการณ์</h2>
      <div class="mt-3 form-div">
        <div class="pt-2 pl-5 pr-lg-5 pr-3 pb-3">

          <div id="google-form" class="form-div">
            <!-- สร้าแผนที่และกำหนดคุณสมบัติ -->
            <div class="mt-3 mb-4 row">
              <label class="col-lg-2 col-10  col-form-label ">1. สถานที่เกิดเหตุ</label>
              <b-button class="col-lg-1 col-3 btn-info" style="font-size: 18px" @click="geolocation">ที่ตั้งปัจจุบัน
              </b-button>
              <div class="col-7">
                <gmap-autocomplete
                  id="searchLocation"
                  :placeholder="form.location"
                  class="form-control" @place_changed="setPlace">
                </gmap-autocomplete>
              </div>
            </div>
            <gmap-map :center="startLocation" :zoom="15" style="width: 100%; height: 420px;" @click="setPlaceNEW">
              <!-- สร้าง marker ตามค่า coordinates ที่เราเซตไว้ แล้ว loop ออกมาแสดงผล -->
              <gmap-marker
                v-for="(item, key) in markers"
                :key="key" :clickable="true"
                :position="getPosition(item)"
                @click="toggleInfo()"></gmap-marker>
            </gmap-map>
            <br>
          </div>

          <div class="mt-3 ml-2 row">
            <div class="col-md-10 col-sm-12 form-group row">
              <div class="mt-3 row">
                <div class="col-md-8 col-sm-12 form-group row">
                  <label class="col-lg-3 col-4 col-form-label">สถานที่เกิดเหตุ</label>
                  <div class="col-lg-9  col-8">
                    <input id="location" v-model="form.location"
                           class="form-control" type="text">
                  </div>
                </div>
                <div class="col-md-4 col-sm-6 form-group row">
                  <label class="col-lg-3  col-4 col-form-label">หมู่ที่</label>
                  <div class="col-lg-4  col-8">
                    <input id="village_no" v-model="form.village_no"
                           class="form-control" type="text">
                  </div>
                </div>
                <div class="col-md-4 col-sm-7 form-group row">
                  <label class="col-4 col-form-label">จังหวัด</label>
                  <div class="col-8">
                    <multiselect
                      id="location_province"
                      v-model="form.location_province"
                      :options="optionProvince"
                      class="w-100"
                      deselect-label=""
                      label="name"
                      placeholder="เลือกจังหวัด"
                      select-label=""
                      selectedLabel=""
                      track-by="name"
                      @input="getDistricts(form.location_province)">
                    </multiselect>
                  </div>
                </div>
                <div class="col-md-4 col-sm-6 form-group row">
                  <label class="col-4 col-form-label">อำเภอ</label>
                  <div class="col-8">
                    <multiselect
                      id="location_district"
                      v-model="form.location_district"
                      :allow-empty="false"
                      :options="optionDistrict"
                      class="w-100"
                      deselect-label=""
                      label="name"
                      placeholder="เลือกอำเภอ"
                      select-label=""
                      selectedLabel=""
                      track-by="name"
                      @input="getSubDistricts(form.location_district)">
                    </multiselect>
                  </div>
                </div>
                <div class="col-md-4 col-sm-7 form-group row">
                  <label class="col-4 col-form-label">ตำบล</label>
                  <div class="col-8">
                    <multiselect
                      id="location_sub_district"
                      v-model="form.location_sub_district"
                      :allow-empty="false"
                      :options="optionSubDistrict"
                      class="w-100"
                      deselect-label=""
                      label="name"
                      placeholder="เลือกตำบล"
                      select-label=""
                      selectedLabel=""
                      track-by="name">
                    </multiselect>
                  </div>
                </div>
                <div class="col-md-4 col-sm-7 form-group row">
                  <label class="col-4 col-form-label">ละติจูด</label>
                  <div class="col-8">
                    <input v-model="form.lat"
                           class="form-control"
                           disabled lang="en" type="text">
                  </div>
                </div>
                <div class="col-md-4 col-sm-7 form-group row">
                  <label class="col-4 col-form-label">ลองจิจูด</label>
                  <div class="col-8">
                    <input v-model="form.lng"
                           class="form-control"
                           disabled lang="en" type="text">
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2 col-sm-12 form-group row">
              <!-- upload images https://github.com/lekhang2512/vue-upload-multiple-image -->
              <div class="mt-3 row">
                <div id="my-strictly-unique-vue-upload-multiple-image" style="display: flex; justify-content: center;">
                  <vue-upload-multiple-image
                    :data-images="form.image_events"
                    browseText="เลือกรูปภาพ"
                    dragText="รูปภาพสถานที่เกิดเหตุ"
                    editUpload="myIdEdit"
                    idUpload="myIdUpload"
                    markIsPrimaryText=""
                    popupText="รูปภาพสถานที่เกิดเหตุ"
                    primaryText=""
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                    @edit-image="editImage"
                  ></vue-upload-multiple-image>
                </div>
              </div>
            </div>
          </div>


          <div class="mt-3 row">
            <div class="col-lg-6 form-group row">
              <label class="col-4  col-form-label">2. ลักษณะการเกิดเหตุ</label>
              <div class="col-8">
                <div class="input-group ">
                  <select id="type_event" v-model="form.type_event"
                          class="custom-select">
                    <option disabled hidden value="">เลือกลักษณะการเกิดเหตุ</option>
                    <option value="1">การจมน้ำตายและจมน้ำจากอุบัติเหตุ (W65-W74)</option>
                    <option value="2">อุบัติเหตุการขนส่งทางน้ำ (V90-V94)</option>
                    <option value="3">ผู้ประสบภัยจากอุทกภัย/พายุ/แรงธรรมชาติอื่นๆ (X36-X38)</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-3 row">
            <div class="col-lg-5 form-group row">
              <label class="col-lg-5 col-4 col-form-label">3. วันที่เกิดเหตุ</label>
              <div class="col-lg-7 col-8">
                <date-picker id="date_of_event"
                             v-model="form.date_of_event"
                             :format="changeFormat"
                             :lang="lang"
                             :not-after="currentDate"
                             width="100%"
                             @focus="initDate(form.date_of_event)"
                             @calendar-change="convertYear">
                </date-picker>
                <!--                <date-picker :lang="lang"-->
                <!--                             :not-after="currentDate"-->
                <!--                             v-model="form.date_of_event"-->
                <!--                             id="date_of_event"-->
                <!--                             width="100%">-->
                <!--                </date-picker>-->
              </div>
            </div>
            <div class="col-lg-5 form-group row offset-lg-1">
              <label class="col-lg-4 col-4 col-form-label">เวลาที่เกิดเหตุ</label>
              <div id="time_of_event" class="col-4">
                <!--                <date-picker v-model="form.time_of_event"-->
                <!--                             style="width: 100%"-->
                <!--                             lang="en"-->
                <!--                             type="time"-->
                <!--                             valueType="format"-->
                <!--                             format="HH:mm:ss"-->
                <!--                             placeholder="เวลาที่เกิดเหตุการณ์">-->
                <!--                </date-picker>-->
                <multiselect
                  id="hour_of_event"
                  v-model="hour"
                  :options="hourOption"
                  class="w-100"
                  deselect-label=""
                  label="no"
                  placeholder="ชั่วโมง"
                  select-label=""
                  selectedLabel=""
                  track-by="no"
                ></multiselect>
              </div>
              <div class="col-4">
                <multiselect
                  id="minute_of_event"
                  v-model="minute"
                  :options="minuteOption"
                  class="w-100"
                  deselect-label=""
                  label="no"
                  placeholder="นาที"
                  select-label=""
                  selectedLabel=""
                  track-by="no"
                ></multiselect>
              </div>
            </div>
          </div>

          <div class="mt-3 row">
            <div class="col-lg-6 form-group row">
              <label class="col-lg-7 col-md-5 col-6 col-form-label">4. จำนวนคนที่เกิดเหตุในเหตุการณ์เดียวกัน</label>
              <div id="total_patient_div" class="col-lg-3 col-md-3 col-4">
                <input id="total_patient" v-model.number="form.total_patient"
                       class="form-control" min="0" type="number">
              </div>
              <label class="col-lg-2 col-md-1 col-1 col-form-label">คน</label>
            </div>
          </div>
          <div class="mt-3 row">
            <div class="col-lg-3 col-md-6 form-group row">
              <label class="col-lg-5 col-md-3 col-3 col-form-label">เสียชีวิต</label>
              <div class="col-lg-5 col-md-6 col-4">
                <input id="death_patient" v-model.number="form.death_patient"
                       :max="form.total_patient" class="form-control" min="0" type="number" value="0">
              </div>
              <label class="col-lg-1 col-md-1 col-1 col-form-label">คน</label>
            </div>
            <div class="col-lg-3 col-md-6 form-group row">
              <label class="col-lg-5 col-md-3 col-3 col-form-label">บาดเจ็บ</label>
              <div class="col-lg-5 col-md-6 col-4">
                <input id="injury_patient" v-model.number="form.injury_patient"
                       :max="form.total_patient" class="form-control" min="0" type="number" value="0">
              </div>
              <label class="col-lg-1 col-md-1 col-1 col-form-label">คน</label>
            </div>
            <div class="col-lg-3 col-md-6 form-group row">
              <label class="col-lg-5 col-md-3 col-3 col-form-label">ไม่บาดเจ็บ</label>
              <div class="col-lg-5 col-md-6 col-4">
                <input id="injury_patient" v-model.number="form.no_injury_patient"
                       :max="form.total_patient" class="form-control" min="0" type="number" value="0">
              </div>
              <label class="col-lg-1 col-md-1 col-1 col-form-label">คน</label>
            </div>
          </div>


          <div class="mt-3 row ">
            <div class="col-12 form-group">
              <label>5. บรรยายเหตุการณ์ก่อนเกิดเหตุจนกระทั่งจมน้ำ</label>
            </div>
            <div class="offset-1 col-md-8 col-10 form-group">
                            <textarea id="cause_of_event" v-model="form.cause_of_event"
                                      class="form-control" placeholder="- เหตุการณ์เกิดได้อย่างไร เหตุเกิดจากอะไร"
                                      rows="2">
                            </textarea>
            </div>
            <div class="offset-1 col-md-8 col-10 form-group">
                            <textarea id="activity_during_event" v-model="form.activity_during_event"
                                      class="form-control" placeholder="- กิจกรรมที่ทำขณะเกิดเหตุ"
                                      rows="2">
                            </textarea>
            </div>
            <div class="offset-1 col-md-8 col-10 form-group">
                            <textarea id="proceed_after_event" v-model="form.proceed_after_event"
                                      class="form-control" placeholder="- หลังเกิดเหตุดำเนินการอย่างไร"
                                      rows="2">
                            </textarea>
            </div>
          </div>

          <div class="mt-3 row">
            <div class="col-12 row">
              <label class="col-lg-3 col-md-4 col-5 col-form-label">6. ประเภทแหล่งน้ำที่เกิดเหตุ</label>
              <div class="col-lg-4 col-md-5 col-7">
                <div class="input-group mb-3">
                  <multiselect
                    id="type_water"
                    v-model="form.type_water_relation"
                    :options="optionTypeWater"
                    class="style-multiselect"
                    deselect-label=""
                    label="type_water"
                    placeholder="เลือกประเภทแหล่งน้ำที่เกิดเหตุ"
                    select-label=""
                    selectedLabel=""
                    track-by="id">
                  </multiselect>
                </div>
              </div>
              <div class="col-lg-4 col-md-5 col-7 row" v-if="form.type_water_relation && form.type_water_relation.type_water == 'อื่นๆ โปรดระบุ'">
                <label class="col-lg-3 col-4 col-form-label">ระบุ</label>
                <div class="col-lg-9 col-8">
                  <input id="other_type_water" v-model="form.type_water_other"
                         class="form-control" type="text" placeholder="โปรดระบุ">
                </div>
<!--                <label for="other_type_water">ระบุ</label>-->
<!--                <input id="other_type_water" type="text">-->
              </div>
            </div>
            <template v-if="form.type_water_relation" class="col-12">
              <label class="pl-lg-4 pl-4 pr-3 mb-0 col-form-label"
                     style="font-size:20px;color: darkgray;">
                * {{ form.type_water_relation.description }}
              </label>
            </template>

            <div class="mt-3 col-12 row">
              <label id="depth_level_metre" class="col-lg-3 col-md-3 col-4 col-form-label">ระดับความลึก</label>
              <div class="col-lg-2 col-md-4 col-5">
                <div class="input-group mb-3">
                  <input id="depth_level_metre" v-model="form.depth_level_metre"
                         class="form-control" min="0" type="number">
                </div>
              </div>
              <label class="col-2 col-form-label">เมตร</label>
              <div class="offset-lg-0 col-lg-2 offset-md-3 col-md-4 col-5 offset-4">
                <div class="input-group mb-3">
                  <input id="depth_level_centimeter" v-model="form.depth_level_centimeter"
                         class="form-control" max="99" min="0" type="number">
                </div>
              </div>
              <label class="col-2 col-form-label">เซนติเมตร</label>

            </div>

          </div>
          <div class="mt-3 row ">
            <label class="col-12">7. การจัดการแหล่งน้ำเสี่ยง</label>
            <div class="col-md-6 mt-3">
              <label class="col-lg-12 text-head mb-0">ก่อนเกิดเหตุ</label>
              <hr width="90%">
              <div class="offset-1 row col-form-label pb-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="no_management_risk" v-model="form.has_management_risk_before_id"
                         class="custom-control-input"
                         type="radio"
                         value="1"
                         @change="clearCheckboxBefore()">
                  <label class="custom-control-label" for="no_management_risk">ไม่มี</label>
                </div>
              </div>
              <div class="offset-1 row col-form-label pb-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="management_risk_before1" v-model="form.has_management_risk_before_id"
                         class="custom-control-input"
                         type="radio"
                         value="2"
                         @change="clearCheckboxBefore()">
                  <label class="custom-control-label" for="management_risk_before1">มี โปรดระบุ (ตอบได้มากกว่า 1
                    ข้อ)</label>
                </div>
              </div>
              <div class="offset-2 row col-form-label pb-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="management_risk_before2" v-model="form.management_risk_before_id"
                         class="custom-control-input"
                         type="checkbox"
                         value="1" @change="checkboxBefore()">
                  <label class="custom-control-label" for="management_risk_before2">รั้ว</label>
                </div>
              </div>
              <div class="offset-2 row col-form-label pb-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="management_risk_before3" v-model="form.management_risk_before_id"
                         class="custom-control-input"
                         type="checkbox"
                         value="2" @change="checkboxBefore()">
                  <label class="custom-control-label" for="management_risk_before3">ป้ายคำเตือน</label>
                </div>
              </div>
              <div class="offset-2 row col-form-label pb-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="management_risk_before4" v-model="form.management_risk_before_id"
                         class="custom-control-input"
                         type="checkbox"
                         value="3" @change="checkboxBefore()">
                  <label class="custom-control-label" for="management_risk_before4">ห่วงชูชีพ</label>
                </div>
              </div>
              <div class="offset-2 row col-form-label pb-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="management_risk_before5" v-model="form.management_risk_before_id"
                         class="custom-control-input"
                         type="checkbox"
                         value="4" @change="checkboxBefore()">
                  <label class="custom-control-label" for="management_risk_before5">ไม้</label>
                </div>
              </div>
              <div class="offset-2 row col-form-label pb-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="management_risk_before6" v-model="form.management_risk_before_id"
                         class="custom-control-input"
                         type="checkbox"
                         value="5" @change="checkboxBefore()">
                  <label class="custom-control-label" for="management_risk_before6">แกลลอนพลาสติก</label>
                </div>
              </div>
              <div class="offset-2 row col-form-label pb-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="management_risk_before7" v-model="form.management_risk_before_id"
                         class="custom-control-input"
                         type="checkbox"
                         value="6" @change="checkboxBefore()">
                  <label class="custom-control-label" for="management_risk_before7">ขวดน้ำพลาสติก</label>
                </div>
              </div>
              <div class="offset-2 row col-form-label pb-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="management_risk_before8" v-model="form.management_risk_before_id"
                         class="custom-control-input"
                         type="checkbox"
                         value="7" @change="checkboxBefore()">
                  <label class="custom-control-label" for="management_risk_before8">เชือก</label>
                </div>
              </div>
              <div class="offset-2 row pb-0">
                <div class="col-lg-4 col-5 col-form-label custom-control custom-checkbox custom-checkbox">
                  <input id="management_risk_before9" v-model="form.management_risk_before_id"
                         class="custom-control-input col-1"
                         type="checkbox"
                         value="8"
                         @change="checkboxBefore()">
                  <label class="custom-control-label"
                         for="management_risk_before9">
                    อื่นๆ โปรดระบุ
                  </label>
                </div>
                <div class="col-5 input-group mb-3 pl-0 pr-0">
                  <input
                    id="other_management_risk_before"
                    v-model="form.other_management_risk_before"
                    :disabled="form.has_management_risk_before_id != null && ( form.has_management_risk_before_id ==1 || !form.management_risk_before_id.includes('8'))"
                    class="form-control" type="text">
                </div>
              </div>

            </div>
            <div class="vl"></div>
            <div class="col-md-6 mt-3 pl-0">
              <label class="col-lg-12 text-head mb-0">หลังเกิดเหตุ (1 เดือน)</label>
              <hr width="90%">
              <div class="offset-1 row col-form-label pb-0">
                <div class="custom-control custom-checkbox ">
                  <input id="no_management_risk_after" v-model="form.has_management_risk_after_id"
                         class="custom-control-input"
                         name="has_deliver"
                         type="radio" value="1"
                         @change="clearCheckboxAfter()">
                  <label class="custom-control-label" for="no_management_risk_after">ไม่มี</label>
                </div>
              </div>
              <div class="offset-1 row col-form-label pb-0 ">
                <div class="pl-0 custom-control custom-checkbox custom-checkbox">
                  <div class="custom-control custom-checkbox ">
                    <input id="management_risk_after" v-model="form.has_management_risk_after_id"
                           class="custom-control-input"
                           name="has_deliver" type="radio"
                           value="2">
                    <label class="custom-control-label" for="management_risk_after">มี โปรดระบุ (ตอบได้มากกว่า 1
                      ข้อ)</label>
                  </div>
                </div>
              </div>
              <div class="offset-2 row col-form-label pb-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="management_risk_after2" v-model="form.management_risk_after_id"
                         class="custom-control-input"
                         type="checkbox"
                         value="1" @change="checkboxAfter()">
                  <label class="custom-control-label" for="management_risk_after2">รั้ว</label>
                </div>
              </div>
              <div class="offset-2 row col-form-label pb-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="management_risk_after3" v-model="form.management_risk_after_id"
                         class="custom-control-input"
                         type="checkbox"
                         value="2" @change="checkboxAfter()">
                  <label class="custom-control-label" for="management_risk_after3">ป้ายคำเตือน</label>
                </div>
              </div>
              <div class="offset-2 row col-form-label pb-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="management_risk_after4" v-model="form.management_risk_after_id"
                         class="custom-control-input"
                         type="checkbox"
                         value="3" @change="checkboxAfter()">
                  <label class="custom-control-label" for="management_risk_after4">ห่วงชูชีพ</label>
                </div>
              </div>
              <div class="offset-2 row col-form-label pb-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="management_risk_after5" v-model="form.management_risk_after_id"
                         class="custom-control-input"
                         type="checkbox"
                         value="4" @change="checkboxAfter()">
                  <label class="custom-control-label" for="management_risk_after5">ไม้</label>
                </div>
              </div>
              <div class="offset-2 row col-form-label pb-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="management_risk_after6" v-model="form.management_risk_after_id"
                         class="custom-control-input"
                         type="checkbox"
                         value="5" @change="checkboxAfter()">
                  <label class="custom-control-label" for="management_risk_after6">แกลลอนพลาสติก</label>
                </div>
              </div>
              <div class="offset-2 row col-form-label pb-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="management_risk_after7" v-model="form.management_risk_after_id"
                         class="custom-control-input"
                         type="checkbox"
                         value="6" @change="checkboxAfter()">
                  <label class="custom-control-label" for="management_risk_after7">ขวดน้ำพลาสติก</label>
                </div>
              </div>
              <div class="offset-2 row col-form-label pb-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="management_risk_after8" v-model="form.management_risk_after_id"
                         class="custom-control-input"
                         type="checkbox"
                         value="7" @change="checkboxAfter()">
                  <label class="custom-control-label" for="management_risk_after8">เชือก</label>
                </div>
              </div>
              <div class="offset-2 row pb-0">
                <div class="col-lg-4 col-5 col-form-label custom-control custom-checkbox custom-checkbox">
                  <input id="management_risk_after9" v-model="form.management_risk_after_id"
                         class="custom-control-input col-1"
                         type="checkbox"
                         value="8"
                         @change="checkboxAfter()">
                  <label class="custom-control-label"
                         for="management_risk_after9">
                    อื่นๆ โปรดระบุ
                  </label>
                </div>
                <div class="col-5 input-group mb-3 pl-0 pr-0">
                  <input
                    id="other_management_risk_after"
                    v-model="form.other_management_risk_after"
                    :disabled="form.has_management_risk_after_id !=null && (form.has_management_risk_after_id ==1 || !form.management_risk_after_id.includes('8'))"
                    class="form-control" type="text">
                </div>
              </div>

            </div>
            <hr class="mr-5">
          </div>
        </div>

      </div>
    </form>

    <div class="mt-5 text-center">
      <b-button class="btn-submit"
                @click="saveEvent">
        บันทึก
      </b-button>
    </div>
    <!--              <pre class="alert-primary">{{form.management_risk_before_id.length}}</pre>-->
    <!--                    <pre class="alert-danger">{{form}}</pre>-->
    <!--                    <pre class="alert-success">{{ images_event }}</pre>-->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Multiselect from 'vue-multiselect'
import DatePicker from 'vue2-datepicker/lib/datepicker.js'
import moment from 'moment'
import VueUploadMultipleImage from 'vue-upload-multiple-image'
import Service from '../../service'

export default {
  name: 'EventForm',
  components: {
    DatePicker,
    Multiselect,
    VueUploadMultipleImage,
  },
  props: {
    id: { default: null }
  },
  created () {
    this.$swal.close()
    this.$store.dispatch('Common/setProvince')
    this.$store.dispatch('Common/setTypeWater')
    this.$store.dispatch('Common/setDepartments')
    this.getCurrentDate()
    if (this.form.id) {
      this.markers.push({ position: this.startLocation })
    }

    for (let i = 1; i < 25; i++) {
      this.hourOption.push({
        no: i < 10 ? '0' + i : i,
      })
    }

    for (let i = 0; i <= 60; i++) {
      this.minuteOption.push({
        no: i < 10 ? '0' + i : i,
      })
    }


    if (this.form.time_of_event) {
      this.hour = { no: this.form.time_of_event.slice(0, 2) }
      this.minute = { no: this.form.time_of_event.substring(3, 5) }
    }
    if (this.minute == null || this.minute == '' || this.minute == undefined) {
      return this.minute = this.minuteOption.find(option => option.id === this.minuteOption[0].no)
    }

    let district = this.form.location_district
    let sub_district = this.form.location_sub_district
    if (this.form.location_province) {
      this.getDistricts(this.form.location_province)
      this.getSubDistricts(district)
      this.form.location_district = district
      this.form.location_sub_district = sub_district
    }
  },
  data () {
    return {
      titleOptions: ['นาย', 'นาง', 'นางสาว', 'อื่นๆ'],
      currentLocation: { lat: 0, lng: 0 },
      images: [],
      hourOption: [],
      hour: '',
      minuteOption: [],
      minute: '',
      changeFormat: {
        stringify: (date) => {
          return date ? moment(date).add(543, 'y').format('DD-MM-YYYY') : null
        },
        parse: (value) => {
          return value ? moment(value, 'DD-MM-YYYY').subtract(543, 'y').toDate() : null
        }
      },
      lang: {
        days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
        months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
        pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
        placeholder: {
          date: 'วว/ดด/ปปปป',
        }
      },
      management_risk: [],
      dateCurrent: new Date().toISOString().slice(0, 10),
      time: '',
      currentDate: '',
      my_district: null,
      my_subdistrict: null,
      my_province: null,
      infoPosition: null,
      infoContent: null,
      subDistrict: null,
      district: null,
      province: null,
      latitude: null,
      longtitude: null,
      infoOpened: true,
      infoCurrentKey: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      places: [],
      show: true,
      currentPlace: [],
      images_event: [],
    }
  },
  computed: {
    ...mapState({
      user_login: state => {
        return state.Auth.user_login
      },
      form: state => {
        return state.Event.form
      },
      optionProvince: state => {
        return state.Common.provinces
      },
      optionDistrict: state => {
        return state.Common.districts
      },
      optionSubDistrict: state => {
        return state.Common.sub_districts
      },
      optionTypeWater: state => {
        return state.Common.type_water
      },
      optionDepartments: state => {
        return state.Common.departments
      },
      startLocation: state => {
        return state.Event.startLocation
      },
      form_patient: state => {
        return state.Patient.form
      },
    }),
  },
  mounted () {
    // console.log(this.startLocation)
    // this.setPlace(this.startLocation)
    if (!this.startLocation) {
      this.geolocation()
    }

  },
  methods: {

    // Convert 2020 to 2563
    initDate (date) {
      const d = new Date(date)
      if (Object.prototype.toString.call(d) === '[object Date]') {
        // it is a date
        if (isNaN(d.getTime())) {  // d.valueOf() could also work
          // date is not valid
          date = new Date()
        } else {
          // date is valid
          date = new Date(date)
        }
      } else {
        // not a date
        date = new Date()
      }
      this.convertYear(date)
    },
    convertYear (date, oldDate, type) {
      const calendarYear = date.getFullYear()
      for (const item of document.getElementsByClassName('mx-current-year')) {
        item.href = '#'
        const innerHTML = item.innerHTML
        const innerHTMLsplit = innerHTML.split(' ~ ')
        if (innerHTMLsplit.length === 2) {
          item.innerHTML = `${(calendarYear - 9) + 543} ~ ${calendarYear + 543}`
        } else {
          item.innerHTML = `${calendarYear + 543}`
        }
      }
    },

    // Upload Images
    uploadImageSuccess (formData, index, fileList) {
      // console.log('data', formData, index, fileList)
      this.images_event = fileList
      // Upload image api
      // axios.post('http://your-url-upload', formData).then(response => {
      //   console.log(response)
      // })
    },
    beforeRemove (index, done, fileList) {
      var r = confirm('remove image')
      if (r == true) {
        done()
      } else {
      }
    },
    editImage (formData, index, fileList) {
      // console.log('edit data', formData, index, fileList)
    },

    getCurrentDate () {
      this.currentDate = moment().format('YYYY-MM-DD')
    },
    validPhoneNumber: function (phone_number) {
      var re = /^[0][0-9]{8}$/
      var re2 = /^[0][0-9]{9}$/
      if (phone_number.match(re) || phone_number.match(re2)) {
        return true
      } else {
        return false
      }
    },
    getDistricts (province) {
      if (province) {
        this.form.location_district = null
        this.form.location_sub_district = null
        this.$store.dispatch('Common/setDistrict', province.code)
      }
    },
    getSubDistricts (district) {
      if (district) {
        this.form.location_sub_district = null
        this.$store.dispatch('Common/setSubDistrict', district.district_id)
      }
    },
    clearCheckboxBefore () {
      if (this.form.has_management_risk_before_id == 1) {
        this.form.management_risk_before_id = []
        this.form.other_management_risk_before = ''
      }
    },
    checkboxBefore () {
      if ((this.form.has_management_risk_before_id == 1 || this.form.has_management_risk_before_id == '') && this.form.management_risk_before_id.length > 0) {
        this.form.has_management_risk_before_id = 2
      }
    },
    checkboxAfter () {
      if ((this.form.has_management_risk_after_id == 1 || this.form.has_management_risk_after_id == '') && this.form.management_risk_after_id.length > 0) {
        this.form.has_management_risk_after_id = 2
      }
    },
    clearCheckboxAfter () {
      if (this.form.has_management_risk_after_id == 1) {
        this.form.management_risk_after_id = []
        this.form.other_management_risk_after = ''
      }
    },
    showErrorFill (element, message) {
      this.$scrollTo(element, 1000, { easing: 'ease', cancelable: false, offset: -100 })
      const Toast = this.$swal.fire({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        type: 'error',
        title: message
      })
    },
    saveEvent () {
      if (!this.form.name) {
        this.showErrorFill('#name', 'กรุณากรอกชื่อผู้รายงาน')
      } else if (!this.form.role) {
        this.showErrorFill('#role', 'กรุณากรอกตำแหน่ง')
      } else if (!this.form.department) {
        this.showErrorFill('#department', 'กรุณากรอกหน่วยงาน')
      } else if (!this.form.department_name) {
        this.showErrorFill('#department-name', 'กรุณากรอกชื่อหน่วยงาน')
      } else if (!this.form.province_department) {
        this.showErrorFill('#province_department', 'กรุณากรอกเลือกจังหวัด')
      } else if (!this.form.phone_number_department) {
        this.showErrorFill('#phone_number_department', 'กรุณากรอกเบอร์โทรศัพท์')
      } else if (!this.validPhoneNumber(this.form.phone_number_department)) {
        this.showErrorFill('#phone_number_department', 'กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง เช่น 0102345678')
      } else if (!this.form.report_date) {
        this.showErrorFill('#report_date', 'กรุณาเลือกวันที่รายงาน')
      } else if (!this.form.location) {
        this.showErrorFill('#searchLocation', 'กรุณากรอกสถานที่เกิดเหตุ')
        // } else if (!this.form.village_no) {
        //     this.showErrorFill('#village_no', 'กรุณากรอกหมู่');
      } else if (!this.form.location_province) {
        this.showErrorFill('#location_province', 'กรุณาเลือกจังหวัดสถานที่เกิดเหตุ')
      } else if (!this.form.location_district) {
        this.showErrorFill('#location_district', 'กรุณาเลือกอำเภอสถานที่เกิดเหตุ')
      }
        // else if (!this.form.location_sub_district) {
        //     this.showErrorFill('#location_sub_district', 'กรุณาเลือกตำบลสถานที่เกิดเหตุ');
        // }
        // else if (!this.form.type_event) {
        //     this.showErrorFill('#type_event', 'กรุณาเลือกลักษณะการเกิดเหตุ');
        // }
        // else if (!this.form.date_of_event) {
        //     this.showErrorFill('#date_of_event', 'กรุณาเลือกวันที่เกิดเหตุ');
      // }
      else if (!this.hour && !this.minute) {
        this.showErrorFill('#time_of_event', 'กรุณาเลือกเวลาที่เกิดเหตุ')
      } else if (this.minute == '' || this.minute == undefined) {
        this.showErrorFill('#time_of_event', 'กรุณาเลือกเวลาที่เกิดเหตุ')
      } else if (!this.form.total_patient) {
        this.showErrorFill('#total_patient', 'กรุณากรอกจำนวนผู้เกิดเหตุ')
      } else if (((this.form.injury_patient === '' ? 0 : this.form.injury_patient) + (this.form.death_patient === '' ? 0 : this.form.death_patient) + (this.form.no_injury_patient === '' ? 0 : this.form.no_injury_patient)) != this.form.total_patient) {
        this.showErrorFill('#total_patient', 'กรุณากรอกจำนวนผู้บาดเจ็บและผู้เสียชีวิตให้ถูกต้อง')
      }
        // else if (!this.form.cause_of_event) {
        //     this.showErrorFill('#cause_of_event', 'กรุณากรอกสาเหตุการเกิดเหตุการณ์');
        // }
        // else if (!this.form.activity_during_event) {
        //     this.showErrorFill('#activity_during_event', 'กรุณากรอกกิจกรรมทีท่าขณะเกิดเหตุ');
        // }
        // else if (!this.form.proceed_after_event) {
        //     this.showErrorFill('#proceed_after_event', 'กรุณากรอกการดำเนินการหลังเกิดเหตุการณ์');
        // }
        // else if (!this.form.type_water) {
        //     this.showErrorFill('#type_water', 'กรุณาเลือกประเภทของแหล่งน้ำที่เกิดเหตุ');
        // }
        // else if (!this.form.depth_level_metre && !this.form.depth_level_centimeter) {
        //     this.showErrorFill('#depth_level_metre', 'กรุณากรอกระดับความลึกของแหล่งน้ำ')
        // }
        // else if (this.form.depth_level_metre < 0 || this.form.depth_level_centimeter < 0 || this.form.depth_level_centimeter > 99) {
        //     this.showErrorFill('#depth_level_metre', 'กรุณากรอกระดับความลึกของแหล่งน้ำให้ถูกต้อง');
      // }
      else if (this.form.has_management_risk_before_id == '') {
        this.showErrorFill('#has_management_risk_before_id', 'กรุณาเลือกการจัดการแหล่งน้ำเสี่ยงก่อนเกิดเหตุ')
      } else if (this.form.has_management_risk_before_id == 2 && this.form.management_risk_before_id == '') {
        this.showErrorFill('#management_risk_before_id', 'กรุณาเลือกวิธีการจัดการแหล่งน้ำเสี่ยงก่อนเกิดเหตุ')
      } else if (this.form.has_management_risk_before_id == 2 && this.form.management_risk_before_id.includes('8') && !this.form.other_management_risk_before) {
        this.showErrorFill('#has_management_risk_before_id', 'กรุณาระบุวิธีการจัดการแหล่งน้ำเสี่ยงก่อนเกิดเหตุ')
      } else if (this.form.has_management_risk_after_id == '') {
        this.showErrorFill('#has_management_risk_after_id', 'กรุณาเลือกการจัดการแหล่งน้ำเสี่ยงหลังเกิดเหตุ')
      } else if (this.form.has_management_risk_after_id == 2 && this.form.management_risk_after_id == '') {
        this.showErrorFill('#management_risk_after_id', 'กรุณาเลือกวิธีการจัดการแหล่งน้ำเสี่ยงหลังเกิดเหตุ')
      } else if (this.form.has_management_risk_after_id == 2 && this.form.management_risk_after_id.includes('8') && !this.form.other_management_risk_after) {
        this.showErrorFill('#other_management_risk_after', 'กรุณาระบุวิธีการจัดการแหล่งน้ำเสี่ยงหลังเกิดเหตุ')
      } else {
        if (this.form.province_department) {

          this.form.province_department_id = this.form.province_department.id
        }
        if (this.form.department) {

          this.form.department_id = this.form.department.id
        }
        //change date format
        if (this.form.report_date) {
          this.form.report_date = moment(this.form.report_date).format('YYYY-MM-DD')
        }
        if (this.form.location_province) {
          this.form.location_province_id = this.form.location_province.id
        }
        if (this.form.type_water_relation) {
          this.form.type_water_id = this.form.type_water_relation.id
        }
        if (this.form.location_district) {
          this.form.location_district_id = this.form.location_district.id
        }
        if (this.form.location_sub_district) {
          this.form.location_sub_district_id = this.form.location_sub_district.id
        }
        // change date format
        if (this.form.date_of_event) {
          this.form.date_of_event = moment(this.form.date_of_event).format('YYYY-MM-DD')
        }

        if (this.markers[0]) {
          this.form.lat = this.markers[0].position.lat
          this.form.lng = this.markers[0].position.lng
        }

        let data = {
          user_id: this.user_login.user.id,
          name: this.form.name,
          title: this.form.title,
          other_title: this.form.other_title,
          role: this.form.role,
          department_id: this.form.department_id,
          department_name: this.form.department_name,
          province_department_id: this.form.province_department_id,
          phone_number_department: this.form.phone_number_department,
          fax_number_department: this.form.fax_number_department,
          report_date: this.form.report_date,
          location: this.form.location,
          images_event: this.images_event,
          lat: this.form.lat,
          lng: this.form.lng,
          village_no: this.form.village_no,
          location_province_id: this.form.location_province_id,
          location_district_id: this.form.location_district_id,
          location_sub_district_id: this.form.location_sub_district_id,
          type_event: this.form.type_event,
          date_of_event: this.form.date_of_event,
          time_of_event: this.hour.no + ':' + this.minute.no + ':00',
          total_patient: this.form.total_patient,
          death_patient: this.form.death_patient,
          injury_patient: this.form.injury_patient,
          no_injury_patient: this.form.no_injury_patient,
          cause_of_event: this.form.cause_of_event,
          activity_during_event: this.form.activity_during_event,
          proceed_after_event: this.form.proceed_after_event,
          type_water_id: this.form.type_water_id,
          type_water_other: this.form.type_water_other,
          depth_level_metre: this.form.depth_level_metre,
          depth_level_centimeter: this.form.depth_level_centimeter,
          has_management_risk_before_id: this.form.has_management_risk_before_id,
          management_risk_before_id: this.form.management_risk_before_id.toString(),
          has_management_risk_after_id: this.form.has_management_risk_after_id,
          management_risk_after_id: this.form.management_risk_after_id.toString(),
          other_management_risk_before: this.form.other_management_risk_before,
          other_management_risk_after: this.form.other_management_risk_after,
        }
        const order = 1
        this.$store.dispatch('Event/saveEvent', {
          id: this.form.id,
          data: data
        }).then(data => {
          this.$store.dispatch('Event/showEvent', {
            id: this.form.id,
            skipLog: true
          })
          this.showSaveEvenFill()

          this.$store.dispatch('Patient/showPatient', {
            event_id: this.form.id,
            order: 1
          }).then(() => {
            if (this.form_patient.id) {
              this.$router.push({
                name: 'DrowningForm',
                params: { order },
              })
            } else {
              this.$store.dispatch('Patient/clearFormData')
              this.$store.dispatch('Patient/setOrder', order)
              this.$router.push({
                name: 'DrowningForm',
                params: { order }
              })
            }
          })

          // this.$store.dispatch("Patient/setOrder", order);
          // this.$router.push({
          //     name: "DrowningForm",
          //     params: {order}
          // })
        })

      }
    },
    showSaveEvenFill (message) {
      // const Toast = this.$swal.fire(
      //     'บันทึกเรียบร้อย',
      // )
      const Toast = this.$swal.fire({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        type: 'success',
        title: 'บันทึกเรียบร้อย'
      })
    },
    //set ตำแหน่งของ marker
    getPosition (marker) {
      return {
        lat: parseFloat(marker.position.lat),
        lng: parseFloat(marker.position.lng)
      }
    },
    //****** */
    toggleInfo () {
      this.infoOpened = true
    },
    setLocation (marker) {
      console.log(marker)
      this.markers.pop()
      this.markers.push({ position: marker })
      this.form.lat = marker.lat
      this.form.lng = marker.lng
      this.startLocation.lat = marker.lat
      this.startLocation.lng = marker.lng
      this.center = marker
      // if(this.form.location_province){
      //     this.form.location_province= null;
      //     this.form.location_district= null;
      //     this.form.location_sub_district= null;
      // }

    },
    geolocation () {
      console.log('current location', navigator.geolocation)
      navigator.geolocation.getCurrentPosition(pos => {
        var current = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude
        }

        var google_map_pos = new google.maps.LatLng(current.lat, current.lng)

        var self = this
        /* Use Geocoder to get address */
        var google_maps_geocoder = new google.maps.Geocoder()
        google_maps_geocoder.geocode(
          { 'latLng': google_map_pos },
          function (results, status) {
            if (status == google.maps.GeocoderStatus.OK && results[0]) {
              self.getAddress(results[0])
            }
          }
        )

        this.setLocation(current)
      }, err => {
        console.log(err)
      })
    },
    setPlace (place) {
      //"1839 Phahonyothin Rd, Khwaeng Lat Yao, Khet Chatuchak, Krung Thep Maha Nakhon 10900, Thailand"
      this.currentPlace = place
      if (this.currentPlace) {

        this.form.location = place.name
        // this.form.location_province = place.address_components[3].long_name;
        // this.form.location_district = place.address_components[2].long_name;
        // this.form.location_sub_district = place.address_components[1].long_name;

        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        }
        this.setLocation(marker)
        this.places.push(this.currentPlace.name)

        console.log('place', place)
        this.getAddress(place)

      } else if (this.form.name) {
        this.places.push(this.form.name)
      }
    },
    setPlaceNEW (place) {
      console.log('newPlace', place)
      let latLngtxt = place.latLng.toString()
      var setlatLng = latLngtxt.split(/[\s,()]+/)
      const marker = {
        lat: Number(setlatLng[1]),
        lng: Number(setlatLng[2])
      }
      // console.log(marker);

      this.setLocation(marker)

      var geocoder = new google.maps.Geocoder()
      var self = this
      geocoder.geocode({ 'location': place.latLng, 'language': 'th' }, function (results, status) {
        if (status === 'OK') {
          console.log('results', results)
          // results.forEach(self.getAddress);
          self.getAddress(results[0])
        }
      })
      //
      // let newCurrentPlace = place.latLng.toString()
      // let latLng = newCurrentPlace.split(/[\s,()]+/)
      // this.currentPosition = { lat: Number(latLng[1]), lng: Number(latLng[2]) }
      // console.log(place);
    },
    getAddress (item, index) {
      var address = item.address_components
      console.log('address', item)
      this.form.location = item.formatted_address
      address.forEach(this.getAddress1)
      this.setSelectLocation(this.my_province, this.my_district, this.my_subdistrict)
    },

    getAddress1 (item, index) {

      console.log(index)
      var type = item.types[0]

      if (type == 'political') {
        if (item.types.length > 2) {
          type = item.types[2]
        }
      }
      console.log('type1', type)
      console.log('address1', type, item.long_name)
      var long_name = item.long_name
      if (type === 'sublocality_level_1') { //เขต
        this.my_district = long_name.replace('อำเภอ', '').replace('เขต', '').trim()
        if (long_name.includes('ตำบล') || long_name.includes('แขวง')) {
          this.my_subdistrict = long_name.replace('ตำบล', '').replace('แขวง', '').trim()
        }
      } else if (type === 'sublocality_level_2') { //แขวง
        this.my_subdistrict = long_name.replace('ตำบล', '').replace('แขวง', '').trim()
      } else if (type === 'administrative_area_level_1') { //จังหวัด
        this.my_province = long_name.replace('จังหวัด', '').trim()
      } else if (type === 'administrative_area_level_2') { //อำเภอ
        this.my_district = long_name.replace('อำเภอ', '').replace('เขต', '').trim()
      } else if (type === 'locality') { //ตำบล
        this.my_subdistrict = long_name.replace('ตำบล', '').replace('แขวง', '').trim()
      }

      // if ((type == 'locality' && item.long_name != 'กรุงเทพมหานคร')
      //   || (type == 'political' && item.long_name == 'กรุงเทพมหานคร')) {
      //   var my_province = item.address_components[2].long_name;
      //   var my_district = item.address_components[1].long_name;
      //   my_district = my_district.replace("อำเภอ", "").replace("เขต", "").trim();
      //   var my_subdistrict = item.address_components[0].long_name;
      //   // console.log(my_subdistrict)
      //   my_subdistrict = my_subdistrict.replace("ตำบล", "").replace("แขวง", "").trim();
      //   // console.log(my_province);
      //   // console.log(my_district);
      //   // console.log(my_subdistrict);
      //   this.setSelectLocation(my_province, my_district, my_subdistrict)
      //   for (var i = 1; i <= 3; i++) {
      //     setTimeout(this.setSelectLocation, 300 * i, my_province, my_district, my_subdistrict);
      //   }
      // }
    },
    setSelectLocation (province, district, subdistrict) {
      console.log(Date.now(), province, district, subdistrict)
      var self = this
      this.optionProvince.forEach(async function (data, index) {
        if (data.name.trim().includes(province)) {

          console.log('province data', data)
          // if (!self.form.location_province || !self.form.location_province.name.trim().includes(province)) {
          //     self.form.location_district = null
          //     self.getDistricts(data)
          // }
          self.form.location_district = null
          self.getDistricts(data)
          self.form.location_province = data

          var self_2 = self
          self.optionDistrict.forEach(async function (data, index) {
            if (data.name.trim().includes(district)) {
              console.log('district data', data)

              self_2.getSubDistricts(data)
              self_2.form.location_district = data

              var self_3 = self_2
              Service.Common.getSubDistrict(data.district_id)
                .then(res => {
                  res.forEach(async function (data, index) {
                    if (data.name.trim().includes(subdistrict)) {
                      console.log('sub district data', subdistrict)
                      self_3.form.location_sub_district = data
                    }
                  })
                })
            }
          })
        }
      })
    },
    geocodeLatLng (geocoder, map, infowindow) {
      var input = document.getElementById('latlng').value
      var latlngStr = input.split(',', 2)
      var latlng = { lat: parseFloat(latlngStr[0]), lng: parseFloat(latlngStr[1]) }
      geocoder.geocode({ 'location': latlng }, function (results, status) {
        // console.log(results[0]);
        if (status === 'OK') {
          if (results[0]) {
            map.setZoom(15)
            var marker = new google.maps.Marker({
              position: latlng,
              map: map
            })
            infowindow.setContent(results[0].formatted_address)

            infowindow.open(map, marker)
          } else {
            window.alert('No results found')
          }
        } else {
          window.alert('Geocoder failed due to: ' + status)
        }
      })
    }
  }
}
</script>

<style scoped>
#preview {
  object-fit: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  max-width: 100%;
  max-height: 100px;
}

.btn-submit {
  font-size: 28px;
  font-weight: 700;
  background-color: #006738;
  padding: 4px 25px;
}

.style-multiselect {
  padding-left: 15px;

}

.text-head {
  color: #606060;
  font-weight: 700;
  text-align: center;
}

.form-div {
  padding-top: 10px;
  background: #FCFCFC;
  border-radius: 8px;
  /*box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);*/
}

.form-div label {
  font-size: 20px;
  color: #606060;
}

.custom-select option {
  font-size: 20px !important;
  color: #606060 !important;
  font-weight: 700 !important;
}

.custom-select {
  font-size: 20px !important;
  color: #606060 !important;
  font-weight: 700 !important;
}

.form-control {
  font-size: 20px;
  font-weight: 700;
  color: #606060;
}

textarea {
  resize: none;
}

option {
  font-size: 19px;
  font-weight: 700 !important;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #006738;
  background-color: #006738;
}

.custom-control-label::before {
  background-color: #FCFCFC;
  border: #006738 solid 2px;
}

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-color: #FCFCFC;
  border: #006738 solid 2px;
  border-radius: 4px;
}

.vl {
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  height: 450px;
  width: 6px;
  margin-left: -7px;
}

hr {
  border-top: 1px solid rgba(0, 0, 0, 0.2)
}

.mx-datepicker {
  font-family: 'THSarabunNew', sans-serif !important;
  color: #495057 !important;
}

@media only screen and (max-width: 767px) {
  .vl {
    border-left: 0;
  }

  h2 {
    font-size: 1.5em;
  }

  .form-div label {
    font-size: 19px;
  }

  .form-div input {
    font-size: 19px;
  }
}

@media only screen and (max-width: 400px) {
  .form-div label {
    font-size: 17px;
    color: #606060;
  }

  h2 {
    font-size: 1.5em;
  }

  .form-div label {
    font-size: 15px;
  }

  .form-div input {
    font-size: 15px;
  }

  #my-strictly-unique-vue-upload-multiple-image {
    font-family: 'THSarabunNew', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
}
</style>
